module.exports = {
  backgroundColor: '#ffffff', // Used for setting manifest background color.
  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.
  siteDescription: 'Overture', // Website description used for RSS feeds/meta description tag.
  siteTitle: 'Overture Bio', // Site title.
  siteTitleAlt: 'Overture Bio', // Alternative site title for SEO.
  siteUrl: 'https://overture.bio', // Domain of your website without pathPrefix.
  themeColor: '#00d1b2', // Used for setting manifest and progress theme colors.
};
